export default "__VITE_ASSET__BSO12Eza__"